export default ['protein', 'fat', 'fiber', 'calories'];
